import * as React from 'react';
import './checkout.css';
// import Button from '../custom_components/button/button.component';
import { StoreState, CustomAction } from '../store';
import { Dispatch, bindActionCreators } from 'redux';
import { selectGeneric } from '../store/actions/generic.actions';
import { Signup_Obj } from '../store/reducers/signup_input.reducers';
import { connect } from 'react-redux';
// import { withRouter } from 'react-router';
import { History } from 'history';
import { Signup_Details_Obj } from '../store/reducers/signup_details.reducers';
import { Checkout_Obj, Checkout_Stage_Obj } from '../store/reducers/checkout_stage.reducers';
import Button from '../custom_components/button/button.component';

import 'react-phone-number-input/style.css'
import PhoneInput from 'react-phone-number-input'
import { isValidPhoneNumber } from 'react-phone-number-input';

// import Button from '../custom_components/button/button.component';

export interface CheckoutA_Props {
    signup_form: Signup_Obj;
    signup_details: Signup_Details_Obj;
    checkout: Checkout_Obj;
    checkout_stage: Checkout_Stage_Obj;

    updateForm: Function;
    updateStage: Function;
}

export interface Country_Obj {
    name: string;
    short_name: string;
    code: string;
}

class CheckoutA extends React.PureComponent<CheckoutA_Props> {

    render() {

        return (
            <div className="checkout-cta">
                <span className="checkout-cta-title">{this.props.checkout.title_text}</span>
                <div className="checkout-cta-text-box">
                    <span className="checkout-cta-sub-title">{this.props.checkout.sub_title_text}</span>
                </div>
                <div className="checkout-signup-form">
                    <div className="checkout-signup-field">
                        <span className="checkout-signup-input-title">Email</span>
                        <input 
                            onChange={this.emailInput} 
                            autoComplete="email" 
                            className={
                                'checkout-signup-input' + (this.props.signup_form.valid ? ' valid-input' : ' invalid-input')
                            } 
                            value={this.props.signup_form.value}
                            type="email" 
                            placeholder="Email address" 
                            name="name"/>
                    </div>
                    <span className="checkout-cta-warn-text">
                        {this.props.signup_form.value != '' && !this.props.signup_form.valid ? 'It seems like you have entered an invalid email address' : ''}
                    </span>
                    <div className="checkout-signup-field">
                        <span className="checkout-signup-input-title">Organization</span>
                        <input 
                            onChange={this.formInput.bind(this, 'business_name')} 
                            autoComplete="organization" 
                            className={
                                'checkout-signup-input' + (this.props.signup_details.business_name == '' ? ' invalid-input' :  ' valid-input')
                            } 
                            value={this.props.signup_details.business_name}
                            type="text" 
                            placeholder="Organization Name" 
                            name="business_name"/>
                    </div>
                    <div className="checkout-signup-field">
                        <span className="checkout-signup-input-title">Mobile Number</span>
                        <PhoneInput
                            placeholder="Enter phone number"
                            autoComplete="mobile tel-local"
                            country="LK"
                            value={this.props.signup_details.mobile_number}
                            className={
                                'checkout-signup-input' + (!this.props.signup_details.mobile_valid ? ' invalid-input' :  ' valid-input')
                            }
                            onChange={(phone: string) => this.phoneInput('mobile_number', phone)} />
                    </div>
                </div>
                <div className="checkout-nav-box">
                    <Button 
                        className="checkout-nav-button"
                        onClick={this.nextStage} 
                        disabled={!this.props.checkout.form_valid}
                        text="Next" 
                        color="#4eabf5" 
                        text_color="white">
                    </Button>
                </div>
                <div className="checkout-cta-trial-text-box">
                    <span className="checkout-cta-trial-text">{this.props.checkout.comment_text}</span>
                </div>
            </div>
        )
    }

    emailInput = (event: any) => {
        let re = new RegExp("[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?");
        
        let email_validity: boolean = re.test(event.target.value);
        
        let updated_form: Signup_Obj = {
            value: event.target.value,
            valid: email_validity
        }
        this.props.updateForm('SIGNUP_UPDATE', updated_form)

        let fresh_details: Signup_Details_Obj = {
            ...this.props.signup_details,
            email: event.target.value
        };

        if (email_validity) {
            this.props.updateForm('SIGNUP_DETAILS_UPDATE', fresh_details)
        }

        this.validateCheckoutForm(fresh_details, email_validity)
    }

    formInput = (field_name: string, event: any) => {

        let fresh_details: Signup_Details_Obj = {
            ...this.props.signup_details,
            [field_name]: event.target.value
        };

        this.props.updateForm('SIGNUP_DETAILS_UPDATE', fresh_details)

        this.validateCheckoutForm(fresh_details, this.props.signup_form.valid)
    }

    phoneInput = (field_name: string, number: string) => {

        if (number == undefined) number = '';

        let fresh_details: Signup_Details_Obj = {
            ...this.props.signup_details,
            [field_name]: number,
            mobile_valid: isValidPhoneNumber(number)
        };

        this.props.updateForm('SIGNUP_DETAILS_UPDATE', fresh_details)

        this.validateCheckoutForm(fresh_details, isValidPhoneNumber(number))
    }

    validateCheckoutForm = (fresh_details: Signup_Details_Obj, email_validity: boolean) => {
        if (email_validity && fresh_details.business_name != '' && fresh_details.mobile_number != '') {
            let updated_checkout: Checkout_Stage_Obj = {
                ...this.props.checkout_stage,
                [this.props.checkout.id]: {
                    ...this.props.checkout_stage[this.props.checkout.id],
                    form_valid: true
                }
            }

            this.props.updateStage('CHECKOUT_UPDATE', updated_checkout)
        } else {
            let updated_checkout: Checkout_Stage_Obj = {
                ...this.props.checkout_stage,
                [this.props.checkout.id]: {
                    ...this.props.checkout_stage[this.props.checkout.id],
                    form_valid: false
                }
            }

            this.props.updateStage('CHECKOUT_UPDATE', updated_checkout)
        }
    }

    submitForm = (history: History, event: any) => {
        let fresh_details: Signup_Details_Obj = {
            ...this.props.signup_details,
            email: this.props.signup_form.value
        };

        this.props.updateForm('SIGNUP_DETAILS_UPDATE', fresh_details)

        history.push('/pricing')
    }

    nextStage = () => {
        this.props.updateStage('CHECKOUT_STAGE_UPDATE', {stage: '2'})
    }
}

export function mapStateToProps({ signup_form, signup_details, checkout_stage }: StoreState) {
    return {
      signup_form: signup_form,
      signup_details: signup_details,
      checkout_stage: checkout_stage
    }
}
  
export function mapDispatchToProps(dispatch: Dispatch<CustomAction>) {
    return bindActionCreators({
        updateForm: selectGeneric,
        updateStage: selectGeneric
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(CheckoutA);


// WEBPACK FOOTER //
// ./src/checkout/checkout_a.component.tsx